import { yearsAgoMs } from "react-migration/lib/util/yearsAgoMS";

export const RADIUS_DOMAIN_SIZE = [0, 1, 10];
export const RADIUS_RANGE_PX = [8, 10, 16];

const YESTERDAY_MS = Date.now() - 24 * 60 * 60 * 1000;
export const COLOR_DOMAIN_RANGE_DEFAULT = [yearsAgoMs(5), YESTERDAY_MS];
